export const faIcons = {
    add: "fas fa-plus-circle",
    admin: "fas fa-user-cog",
    arrowCircleLeft: "fas fa-arrow-alt-circle-left",
    arrowLeft: "fas fa-arrow-left",
    arrowRight: "fas fa-arrow-right",
    bars: "fas fa-bars",
    calendar: "fas fa-calendar",
    carrot: "fas fa-carrot",
    check: "fas fa-check",
    checkCircle: "fas fa-check-circle",
    clone: "fas fa-clone",
    copy: "fas fa-copy",
    delete: "fas fa-trash-alt",
    deleteAll: "fas fa-minus-square",
    download: "fas fa-download",
    edit: "fas fa-edit",
    eye: "fas fa-eye",
    file: "fas fa-file-alt",
    fillDrip: "fas fa-fill-drip",
    gear: "fas fa-cog",
    infoCircle: "fas fa-info-circle",
    key: "fas fa-key",
    logOut: "fas fa-sign-out-alt",
    market: "fas fa-store",
    save: "fas fa-save",
    search: "fas fa-search",
    spinner: "fa fa-spinner",
    storeSlash: "fas fa-store-slash",
    sync: "fas fa-sync-alt",
    upload: "fas fa-upload",
    xClose: "fas fa-times",
    fileUpload: "fas fa-file-upload",
    fileDownload: "fas fa-file-download",
    fileEdit: "fas fa-file-signature",
}